import { GrpcMeta } from './grpc-transport-context';

export const LOGGER_SUFFIX_META = new GrpcMeta<string>();
